import {
  VOUCHER_CREATE,
  VOUCHER_CREATE_FAILURE,
  VOUCHER_CREATE_SUCCESS,
  VOUCHER_HIDE_LOADING,
  VOUCHER_HIDE_SUCCESS,
  VOUCHER_PAY_OFF,
  VOUCHER_PAY_OFF_FAILURE,
  VOUCHER_PAY_OFF_SUCCESS,
  VOUCHER_SHOW_LOADING,
  VOUCHER_SHOW_SUCCESS,
} from "@shared/constants";
import { post, checkResponse, SAGA_DELAY_SIZE } from "@shared/utils/server";
import { call, fork, put, takeLatest, delay, all } from "redux-saga/effects";

import { updateBalance } from "./user";

export function* createVoucher(action) {
  try {
    yield put({ type: VOUCHER_SHOW_LOADING });

    const { amount } = action.payload;
    const response = yield call(post, {
      method: "Voucher.create",
      args: { amount },
    });

    checkResponse(response);

    yield call(updateBalance);
    yield put({ type: VOUCHER_CREATE_SUCCESS, payload: response[0] });
    yield put({ type: VOUCHER_HIDE_LOADING });
    yield put({ type: VOUCHER_SHOW_SUCCESS });
    yield delay(SAGA_DELAY_SIZE);
    yield put({ type: VOUCHER_HIDE_SUCCESS });
  } catch (error) {
    yield put({ type: VOUCHER_CREATE_FAILURE, payload: error });
  }
}

export function* payOffVoucher(action) {
  try {
    yield put({ type: VOUCHER_SHOW_LOADING });

    const { pin, cvv } = action.payload;
    const response = yield call(post, {
      method: "Voucher.payOff",
      args: { voucher: { pin, cvv } },
    });

    checkResponse(response);

    yield call(updateBalance);
    yield put({ type: VOUCHER_PAY_OFF_SUCCESS, payload: response[0] });
    yield put({ type: VOUCHER_HIDE_LOADING });
    yield put({ type: VOUCHER_SHOW_SUCCESS });
    yield delay(SAGA_DELAY_SIZE);
    yield put({ type: VOUCHER_HIDE_SUCCESS });
  } catch (error) {
    yield put({ type: VOUCHER_PAY_OFF_FAILURE, payload: error });
  }
}

function* watchCreateVoucher() {
  yield takeLatest(VOUCHER_CREATE, createVoucher);
}

function* watchPayOffVoucher() {
  yield takeLatest(VOUCHER_PAY_OFF, payOffVoucher);
}

export default function* voucher() {
  yield all([fork(watchCreateVoucher), fork(watchPayOffVoucher)]);
}
